'use strict';

const Reflux = require('@muzzylane/reflux');
const filter = require('lodash/filter');
const findIndex = require('lodash/findIndex');

const AssignmentActions = require('../actions/AssignmentActions');
const SignInActions = require('../actions/sign_in_actions');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const Globals = require('../../../app/globals');

let localAssignments = [];
let localStudentAssignments = [];
let localAssignmentsMinimal = {};
let localAssignmentAuths = {};
let action = {};
let loading = false;
let requested = false;

const LocalAssignmentsStore = Reflux.createStore({
    listenables: [AssignmentActions,SignInActions],
    init: function() {return},

    resetState: function() {
        localAssignments = [];
        localStudentAssignments = [];
        localAssignmentsMinimal = {};
        localAssignmentAuths = {};
        // action = {};
        loading = false;
        requested = false;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            localAssignments: localAssignments,
            localStudentAssignments: localStudentAssignments,
            localAssignmentsMinimal: localAssignmentsMinimal,
            localAssignmentAuths: localAssignmentAuths,
            loading: loading,
            requested: requested,
            action: action
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null;
    },

    onError: function(actionID, err) {
        action = { id: actionID };

        if (err.status) {
            switch (err.status) {
                case 403: 
                    action.error = new ForgeError({ message: err.responseText, stack: null });
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

   onGetLocalAssignmentMinimalCompleted: function(actionId, assignmentHash, assignmentData) {
        // console.log("onGetLocalAssignmentMinimalCompleted: ", actionId, assignmentHash, assignmentData);
        action = { id: actionId };
        localAssignmentsMinimal[assignmentHash] = assignmentData;
        this.emitStatus();
    },

    onGetLocalAssignmentMinimalFailed: function(actionId, err) {
        // console.warn("onGetLocalAssignmentMinimalFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAuthorizeLocalAssignmentUserCompleted: function(actionId, assignmentHash, res) {
        // console.log("onAuthorizeLocalAssignmentUserCompleted: ", actionId, assignmentHash, res);
        action = { id: actionId };
        localAssignmentAuths[assignmentHash] = res;
        this.emitStatus();
    },

    onAuthorizeLocalAssignmentUserFailed: function(actionId, err) {
        console.warn("onAuthorizeLocalAssignmentUserFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAuthorizeLocalAssignmentAccessCodeCompleted: function(actionId, assignmentHash, res) {
        // console.log("onAuthorizeLocalAssignmentAccessCodeCompleted: ", actionId, assignmentHash, res);
        action = { id: actionId };
        localAssignmentAuths[assignmentHash] = res;
        this.emitStatus();
    },

    onAuthorizeLocalAssignmentAccessCodeFailed: function(actionId, err) {
        console.warn("onAuthorizeLocalAssignmentAccessCodeFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

   onGetLocalAssignmentsStarted: function(actionID) {
        loading = true;
        this.emitStatus();
   },

   onGetLocalAssignmentsCompleted: function(actionID, assignmentData) {
        // console.log("onGetLocalAssignmentsCompleted: ", actionID, assignmentData);
        action.id = actionID;

        localAssignments = filter(assignmentData,{role_token:'INSTRUCTOR'});
        localStudentAssignments = filter(assignmentData,{role_token:'STUDENT'});
        loading = false;

        this.emitStatus();
    },

    onGetLocalAssignmentsFailed: function(actionID, err) {
        console.warn("onGetLocalAssignmentsFailed: ", actionID, err);
        localAssignments = [];
        loading = false;
        this.emitStatus();
        this.onError(actionID, err);
    },

   onArchiveAssignmentCompleted: function(actionID, assignmentHash, res) {
        action = { id: actionID };
        var index = findIndex(localAssignments,{ hash: assignmentHash });
        if (index >= 0) {
            localAssignments.splice(index,1);
            localAssignments = localAssignments.slice(); // clone self
        }

        this.emitStatus();
   },

   onArchiveAssignmentFailed: function(actionID, err) {
        console.warn('onArchiveAssignmentFailed', actionID, err);
        this.onError(actionID, err);
   },
});

module.exports = LocalAssignmentsStore;
